export default "__VITE_ASSET__BaGhnT6c__"